export const GET_PRODUCT = "get_product";
export const GET_PRODUCT_DETAIL = "get_product_detail";
export const GET_PRODUCT_IMAGE_DETAIL = "get_product_image_detail";
export const GET_PRODUCT_RELATED = "get_product_related"
export const GET_ORDER_DETAILS_BY_USERNAME = "get_order_details_by_username"
export const LOGIN_USER = "login_user"
export const CREATE_USER = "create_user"
export const CREATE_ORDER = "create_order"
export const SEND_SMS_TO_CUSTOMER = "send_sms_to_customer"
export const SEARCH_PRODUCTS = "search_products"
export const GET_PRODUCTS_BEST_SELLER = "get_products_best_seller"
export const GET_CUSTOMER_ACCOUNT = "get_customer_account"
export const UPDATE_CUSTOMER_ACCOUNT = "update_customer_account"
export const GET_ORDER_DETAILS_BY_ORDERID = "get_order_details_by_orderid"
export const CHECK_STOCK_PRODUCT = "check_stock_product"
export const GET_PRODUCTS_RATING = "get_products_rating"
export const UPDATE_PRODUCTS_RATING = "update_products_rating"
export const GET_PRODUCTS_INTEREST = "get_products_interest"
export const UPDATE_PRODUCT = "update_product"
export const CREATE_PRODUCT = "create_product"
export const DELETE_PRODUCT = "delete_product"
export const SET_CART_QUANTITY = "set_cart_quantity"
export const INIT_CART = "init_cart"
export const ADD_CART_ITEM = "add_cart_item"
export const UPDATE_CART_ITEM = "update_cart_item"
export const REMOVE_CART_ITEM = "remove_cart_item"
export const GET_PAYMENT_METHOD = "get_payment_method"
export const GET_PROVINCES = "get_provinces"
export const GET_DISTRICTS = "get_districts"
export const GET_WARDS = "get_wards"
export const GET_CATEGORIES = "get_categories"
export const GET_CATEGORIES_DATA = "get_categories_data"
export const PAYMENT_BY_MOMO = "payment_by_momo"
export const PAYMENT_BY_ZALO_PAY = "payment_by_zalo_pay"
export const GET_WISHLIST = "get_wishlist"
export const ADD_TO_WISHLIST = "add_to_wishlist"
export const GET_COMMENTS = "get_comments"
export const CREATE_COMMENT = "create_comment"
export const GET_TEMPLATES = "get_template"

export const CLEAR_PRODUCT_DETAIL = "clear_product_detail";